export default function StatusBadge({ status }: { status?: string }) {
  const s = (status || 'unknown').toLowerCase()
  const cls =
    /(active|healthy|completed|paid|running|approved|delivered|success)/.test(s)
      ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'
      : /(pending|processing|await|created|open|new)/.test(s)
        ? 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400'
        : /(failed|cancel|error|inactive|down|rejected|stopped)/.test(s)
          ? 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400'
          : 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300'
  return <span className={`px-2 py-0.5 rounded-full text-xs font-medium capitalize ${cls}`}>{status || '—'}</span>
}
